import { formatCurrency } from '@coingecko/cryptoformat';

/* ====================== *
 *    get random id    *
 *  https://stackoverflow.com/questions/1349404/generate-random-string-characters-in-javascript
 * * ====================== */
import { getDecimal, USDT_DECIMAL } from '@/constants/decimal';
import { CURRENCY_NAME, CURRENCY_SYMBOLS } from '@/constants/currency';
import addCommatoNumber from './number/addComma';

export function getRandomId(
  length = 8,
  chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
) {
  let result = '';
  for (let i = length; i > 0; --i)
    result += chars[Math.floor(Math.random() * chars.length)];
  return result;
}

export function getUUid() {
  return `${getRandomId(8)}-${getRandomId(4)}-${getRandomId(4)}-${getRandomId(
    4,
  )}-${getRandomId(12)}`;
}

/* ====================== *
 *    copy to clipboard    *
 * ====================== */
export const copyToClipboard = (text: string): Promise<boolean> => {
  return new Promise<boolean>((resolve, reject) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      // 使用 Clipboard API
      navigator.clipboard
        .writeText(text)
        .then(() => {
          resolve(true); // 成功时返回 true
        })
        .catch((error) => {
          reject(false); // 失败时返回 false
        });
    } else if (
      document.queryCommandSupported &&
      document.queryCommandSupported('copy')
    ) {
      // 使用 execCommand
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        resolve(true); // 成功时返回 true
      } catch (error) {
        reject(false); // 失败时返回 false
      }
      document.body.removeChild(textarea);
    } else {
      reject(false); // 不支持复制到剪贴板时返回 false
    }
  });
};

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function formatMoney(value: any, decimal = USDT_DECIMAL) {
  try {
    if (value === undefined || value === null) return '-';
    if (isNaN(value)) return '-';
    return formatCurrency(Number(value), 'usd', 'en', true, {
      decimalPlaces: decimal,
    });
  } catch (e) {
    console.log('🍎🍎🍎formatMoney error value:', value);
    throw new Error(e);
  }
}

export function formatMoneyByCurrency(
  value,
  {
    commas = true,
    decimal = undefined,
    withCurrencySymbol = false,
    currency = CURRENCY_NAME.USDT,
  } = {},
) {
  const usedDecimal = decimal ?? getDecimal(currency, value);
  const valueStr = Number(value < 0.0001 && currency.includes('USD'))
    ? '<0.0001'
    : Number(value < 0.000001)
      ? '<0.000001'
      : formatMoney(value, usedDecimal);
  const formattedValue =
    commas && Number(value) >= 1000 ? addCommatoNumber(valueStr) : valueStr;
  return withCurrencySymbol
    ? CURRENCY_SYMBOLS[currency] + formattedValue
    : formattedValue;
}
